(function ($) {
    $(function () {
        var profileClass = 'profile';
        var dot = '.';

        var contentClass = profileClass + '__content';
        var moreClass = profileClass + '__more';
        var buttonClass = 'button';

        $(dot + profileClass).each(function (profileIndex, profileNode) {
            var profile = $(profileNode);
            var content = profile.find(dot + contentClass);

            if (content.length === 0) {
                return;
            }

            var more = profile.find(dot + moreClass);
            var button = profile.find(dot + buttonClass);

            var showText = profile.data('show-text');
            var hideText = profile.data('hide-text');

            if (!showText) {
                showText = 'Show full description';
            }

            if (!hideText) {
                hideText = 'Hide full description';
            }

            if (button.length === 0) {
                if (more.length === 0) {
                    more = $('<div class="' + moreClass + '">');
                    content.after(more);
                }

                button = $('<button type="button" class="' + buttonClass + '">' + showText + '</button>');
                more.append(button);
            }

            button.on('click', function () {
                content.slideToggle().promise().done(function () {
                    if (content.is(':visible')) {
                        return button.html(hideText);
                    }

                    button.html(showText);
                });
            });

            content.hide();
        });
    });
})(jQuery);
